import { Component, Watch } from 'vue-property-decorator';
import DirectDebitFileTable from '@accounting/components/tables/direct-debit-file-table/direct-debit-file-table.vue';
import InvoiceTable from '@accounting/components/tables/invoice-table/invoice-table.vue';

import Vue from 'vue';

@Component({
  name: 'bpc-direct-debit-files',
  components: {
    'bpc-direct-debit-file-table': DirectDebitFileTable,
    'bpc-invoice-table': InvoiceTable,
  },
})
export default class DirectDebitFiles extends Vue {
  // Selects the table to show 'direct-debit-files' || 'invoices'
  public tableToShow = null;
  //Filter used in the tableToShow
  public filterConfigName: string = '';
  // Extended filters only used in orders at the moment
  public extendedFilterConfigName: string = '';
  // Filter fields to exclude of the table
  public filtersExcluded: string[] = [];
  // Title of the table to show
  public tableTitle = 'global.models.invoice.heading';
  // Subtitle of the table to show
  public tableSubtitle = 'global.models.invoice.subheading';
  // Set the type of accounting journals that shows the generate invoice Form and validate invoice form.
  public accountingJournalsType: string[] = ['credit_note'];
  // Enable/disable  actions. (Disabled by default)
  public validateInvoicePageAction: boolean = null;
  public sendInvoiceAction: boolean = false;
  public syncInvoicePageAction: boolean = false;
  public bulkMoveToTrashPageAction: boolean = false;
  public bulkAddToDirectDebitFilePageAction: boolean = true;
  public markInvoicesAsPaidPageAction: boolean = true;
  // Create invoice form config name
  public formConfigName: string = 'direct-debit-files-form';
  public displayConfigName: string = 'tickets-table-for-direct-debit';
  public withComment: boolean = false;

  mounted() {
    this.onChangeRoute();
  }

  @Watch('$route.name')
  onChangeRoute() {
    switch (this.$route.name) {
      case 'direct-debit-files':
        this.tableToShow = 'direct-debit-files';
        this.filtersExcluded = [''];
        break;
      case 'tickets-for-direct-debit-file':
        this.tableToShow = 'tickets';
        this.filterConfigName = 'to-add-to-direct-debit-file';
        this.filtersExcluded = ['type'];
        this.tableTitle = 'global.tabs.direct_debit_tickets.title';
        this.withComment = false;
        break;
      case 'tickets-refused':
        this.tableToShow = 'tickets';
        this.filterConfigName = 'direct-debit-files-refused';
        this.filtersExcluded = ['type'];
        this.tableTitle = 'global.tabs.refused.title';
        this.withComment = true;
        break;
      default:
        break;
    }
  }
}
